// import Promise from 'bluebird'

// Promise.config({ cancellation: true })

export default Promise



// WEBPACK FOOTER //
// ./src/lib/services/Promise.js